import { Injectable, OnDestroy } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Injectable()
export class TestGuardService implements CanActivate, OnDestroy {
  private isAuthorized: true | UrlTree = true;
  constructor(
    private _Router: Router,
    private permissionsService: NgxPermissionsService
  ) {
    // console.log( "Auth Guard Service instantiated" )
  }
  ngOnDestroy() {
    // console.log( "Auth guard service destroyed" )
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): true | UrlTree {
    // console.log( "AuthGuard Ejecutado" )
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // this.isAuthorized = this._Router.parseUrl('forbidden')
    if (user && user.permissions) {
      this.permissionsService.loadPermissions(user.permissions);
    }
    return this.isAuthorized;
  }
}
